import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download } from "lucide-react";
import { Helmet } from "react-helmet-async";
import ihelmWhitepaperCover from "@/assets/ihelm-whitepaper-cover.png.asset.json";

const WhitePaperIHelmIntro = () => {
  return (
    <>
      <Helmet>
        <title>From data to decisions – iHelm White Paper | Cetasol</title>
        <meta
          name="description"
          content="Learn how iHelm turns vessel data into actionable decisions that improve maritime operations. Download the full white paper."
        />
        <link rel="canonical" href="https://cetasol.com/ihelm-white-paper" />
        <meta property="og:title" content="From data to decisions – iHelm White Paper | Cetasol" />
        <meta property="og:description" content="Learn how iHelm turns vessel data into actionable decisions that improve maritime operations. Download the full white paper." />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://cetasol.com/ihelm-white-paper" />
        <meta property="og:image" content="https://cetasol.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="From data to decisions – iHelm White Paper | Cetasol" />
        <meta name="twitter:description" content="Learn how iHelm turns vessel data into actionable decisions that improve maritime operations. Download the full white paper." />
        <meta name="twitter:image" content="https://cetasol.com/og-image.jpg" />
      </Helmet>
      <Header />
      <main className="min-h-screen pt-24 pb-16">
        <article className="container mx-auto px-6 max-w-3xl">
          <Link
            to="/whitepapers"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft size={16} /> Back to all white papers
          </Link>

          <header className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              From data to decisions: Why vessel data alone isn't enough to improve maritime operations
            </h1>
            <Link to="/whitepaper/ihelm-download" className="inline-block mt-6">
              <Button className="gap-2">
                <Download size={16} /> Download PDF
              </Button>
            </Link>
          </header>

          <img
            src={ihelmWhitepaperCover.url}
            alt="iHelm White Paper cover"
            className="w-full rounded-lg mb-8"
          />

          <div className="prose prose-invert prose-lg max-w-none prose-p:text-foreground/80 prose-p:leading-relaxed prose-p:mb-4">
            <p>
              Learn more about how you vessel data can be used for performance insights. See trends, save fuel and reduce engine downtime by advanced automated data analysis.
            </p>
            <p>
              Download the full iHelm white paper to learn how your operation can benefit from taking actions on data both onboard and online.
            </p>
          </div>

          <div className="mt-10 flex justify-center">
            <Link to="/whitepaper/ihelm-download">
              <Button className="gap-2">
                <Download size={16} /> Download PDF
              </Button>
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
};

export default WhitePaperIHelmIntro;
